import React from "react";
import styles from "./AboutUsPage.module.scss";
import classNames from "classnames/bind";
import Images from "../../asset/images";
import { useLanguageStore } from "../../stores/Language/useLanguageStore";
import { usePageSections } from "../../hooks/usePageSections";
import SectionRenderer from "../../components/SectionRenderer/SectionRenderer";
const cx = classNames.bind(styles);

const AboutUsPage = () => {
  const srcImage = Images.aboutUsImage;
  const { currentLanguage } = useLanguageStore();
  const { sections } = usePageSections("about-us");

  if (sections?.length) {
    return (
      <div className="about-us-page-builder">
        {sections.map((section) => (
          <SectionRenderer key={section.id} section={section} />
        ))}
      </div>
    );
  }

  return (
    <div className={cx("container")}>
      <img
        src={srcImage}
        className={cx("container__background")}
        alt="about us "
      />

      <div className={cx("container__content")}>
        <h1>{currentLanguage === "en" ? "About Us" : "Về Chúng Tôi"}</h1>
        <p>
          {currentLanguage === "en"
            ? "Lianne Jewelry was born as a symbol of elegant and sophisticated beauty, where each design is not just a piece of jewelry but a story told with light and meticulousness."
            : "Lianne Jewelry ra đời như một biểu tượng của vẻ đẹp thanh lịch và tinh tế, nơi mỗi thiết kế không chỉ là một món trang sức mà còn là một câu chuyện được kể bằng ánh sáng và sự tỉ mỉ."}
        </p>
        <p>
          {currentLanguage === "en"
            ? "Inspired by the sparkling moments in life, Lianne chooses to express the brand identity through the combination of classic aesthetics and minimalist modern style. Each product is the crystallization of the art of crafting and the spirit of honoring sustainable values."
            : "Lấy cảm hứng từ những khoảnh khắc lấp lánh trong cuộc sống, Lianne lựa chọn thể hiện bản sắc thương hiệu thông qua sự kết hợp giữa thẩm mỹ cổ điển và phong cách hiện đại tối giản. Mỗi sản phẩm là sự kết tinh của nghệ thuật chế tác và tinh thần tôn vinh các giá trị bền vững."}
        </p>
        <p>
          {currentLanguage === "en"
            ? "We believe that jewelry is not simply an object, but a vivid memory, a preserved emotion, a gift with timeless value. Lianne creates a space for you to find yourself in each design, whether it is a look, an emotion or an unspoken whisper."
            : "Chúng tôi tin rằng trang sức không đơn thuần là một vật thể, mà là một ký ức sống động, một cảm xúc được lưu giữ, một món quà có giá trị vượt thời gian. Lianne tạo ra không gian để bạn tìm thấy chính mình trong từng thiết kế, dù đó là một cái nhìn, một cảm xúc hay một lời thì thầm không nói."}
        </p>
        <p>
          {currentLanguage === "en"
            ? "Lianne is committed to bringing an emotional, sincere and trustworthy shopping and jewelry ownership experience from product quality to every interaction with customers."
            : "Lianne cam kết mang đến trải nghiệm mua sắm và sở hữu trang sức đầy cảm xúc, chân thành và đáng tin cậy từ chất lượng sản phẩm đến mọi tương tác với khách hàng."}
        </p>
        <p>
          {currentLanguage === "en" ? (
            <>
              For Lianne, every ring, necklace or pair of earrings carries its{" "}
              <b>own story</b>, the starting point for your own journey to
              shine.
            </>
          ) : (
            <>
              Đối với Lianne, mỗi chiếc nhẫn, dây chuyền hay đôi bông tai đều
              mang <b>câu chuyện riêng</b>, là điểm khởi đầu cho hành trình tỏa
              sáng của riêng bạn.
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default AboutUsPage;
